/* eslint-disable no-mixed-spaces-and-tabs */
import { createSelector } from 'reselect';
import { initialState } from './reducer';

export const selectIcepacksContainerDomain = state => state.icepacksContainerReducer || initialState;

export const getIsIcepacksLoadingSelector = () =>
	createSelector(selectIcepacksContainerDomain, ({ isIcepacksLoading }) => isIcepacksLoading);

export const getIcepacksSelector = () =>
	createSelector(selectIcepacksContainerDomain, ({ icepacks }) => {
		return icepacks;
	});

export const getPaginationSelector = () =>
	createSelector(selectIcepacksContainerDomain, ({ pagination }) => {
		if (!pagination || pagination?.total === 0) {
			return null;
		}

		return {
			currentPage: pagination.current_page,
			totalPages: pagination.last_page,
			perPage: pagination.per_page,
			total: pagination.total,
			from: pagination.current_page * pagination.per_page - (pagination.per_page - 1),
			to:
				pagination.current_page === pagination.last_page
					? pagination.total
					: pagination.current_page * pagination.per_page,
			isNextItem: true,
			isPrevItem: true,
			isLastItem: false,
			isFirstItem: false,
		};
	});
